import { ref } from 'vue'

export const enterGateTick = ref(0)
export const enterGateMode = ref<'start' | 'done' | 'cancel'>('done')

export const beginEnterGate = () => {
  enterGateMode.value = 'start'
  enterGateTick.value += 1
}

export const finishEnterGate = () => {
  enterGateMode.value = 'done'
  enterGateTick.value += 1
}

export const cancelEnterGate = () => {
  enterGateMode.value = 'cancel'
  enterGateTick.value += 1
}
